import { gql, type TypedDocumentNode } from '@apollo/client';

import { WidgetChip } from '@sorare/core/src/atoms/ui/Chip/WidgetChip/index.tsx';
import { ANY_SPORT_SERIES_MISSIONS_COLLECT } from '@sorare/core/src/constants/__generated__/routes.ts';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { isType, isTypes } from '@sorare/core/src/lib/gql';

import { DumbFeaturedCollectionTaskWidget } from '#src/components/missions/DumbFeaturedCollectionTaskWidget/index.tsx';

import type { FeaturedCollectionTaskWidget_taskInterface } from './__generated__/index.graphql.ts';

type Props = {
  featuredCollectionTask: FeaturedCollectionTaskWidget_taskInterface;
  hasClaimableCollectionTasks: boolean;
};
export const FeaturedCollectionTaskWidget = ({
  featuredCollectionTask,
  hasClaimableCollectionTasks,
}: Props) => {
  const { generateSportContextPath } = useSportContext();

  if (!isType(featuredCollectionTask, 'TasksTrack')) {
    return null;
  }

  const step = featuredCollectionTask.currentStep;
  const stepProgress = isTypes(step, [
    'CardsCountTargetTask',
    'CompleteCollectionsCountTargetTask',
  ])
    ? step.progress / (step.target || 1)
    : 0;

  return (
    <DumbFeaturedCollectionTaskWidget
      to={generateSportContextPath(ANY_SPORT_SERIES_MISSIONS_COLLECT)}
      chip={
        hasClaimableCollectionTasks ? <WidgetChip state="reward" /> : undefined
      }
      progresses={[hasClaimableCollectionTasks ? 1 : stepProgress]}
    />
  );
};

FeaturedCollectionTaskWidget.fragments = {
  taskInterface: gql`
    fragment FeaturedCollectionTaskWidget_taskInterface on TaskInterface {
      id
      ... on TasksTrack {
        id
        currentStep {
          id
          aasmState
          ... on CardsCountTargetTask {
            id
            progress
            target
          }
          ... on CompleteCollectionsCountTargetTask {
            id
            progress
            target
          }
        }
      }
    }
  ` as TypedDocumentNode<FeaturedCollectionTaskWidget_taskInterface>,
};
